import { Helmet } from "react-helmet";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Toolbar,
  Typography,
  Avatar,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect } from "react";
import cssVariables from "../../theme/cssVariables";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import linkedGoal from "../../assets/images/linkedGoal.svg";
import defaultProfile from "../../assets/images/defaultProfile.svg";
import vector from "../../assets/images/vector.svg";
import kpiArrow from "../../icons/kpiArrow.svg";
// import PdfIcon from "../../assets/images/iconFile/pdf.svg";
// import JpgIcon from "../../assets/images/iconFile/jpg.svg";
// import PngIcon from "../../assets/images/iconFile/png.svg";
// import NullIcon from "../../assets/images/iconFile/Null-File.svg";
// import JpegIcon from "../../assets/images/iconFile/jpeg.svg";
import { ReactComponent as PdfIcon } from "../../assets/images/iconFile/pdf.svg";
import { ReactComponent as JpgIcon } from "../../assets/images/iconFile/jpg.svg";
import { ReactComponent as PngIcon } from "../../assets/images/iconFile/png.svg";
import { ReactComponent as NullIcon } from "../../assets/images/iconFile/Null-File.svg";
import * as Util from "../../services/global.service";
import { ReactComponent as Nodata } from "../../assets/icons/nodata.svg";
import { getFileDetail } from "../../actions/achievement";

const useStyles = makeStyles({

});


const DialogAchievements = (props) => {
  const { open, close, data, type } = props
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {

  }, []);
  const handleCloseDialog = () => {
    close(false);
  };
  const openInNewTab = (val) => {
    dispatch(getFileDetail(val)).then((resp) => {
      const newWindow = window.open(resp.data.data, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    })
  }
  return (
    <Dialog onBackdropClick={() => {return false}} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="lg" PaperProps={{ sx: { padding: '30px 30px' } }}>
      <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px" }} color="#404349">
        {t('evaluation.achievementsForThis')}{type === "goal" ? t('evaluation.goal') : t('evaluation.competency')}
        <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ padding: "0" }}>
        <Box sx={{ padding: "20px 0 0px" }}>
          <Box sx={{ display: "flex" }}>
            <Typography fontSize={18} lineHeight="26.91px" color="#404349">
              {t('evaluation.supportedAchievements')}:&nbsp;
            </Typography>
            <Typography fontSize={18} lineHeight="26.91px" color="#5DA196"> {data.length} {t('evaluation.achievements')}</Typography>
          </Box>
        </Box>
        <Box sx={{ "max-height": "calc(100vh - 250px)", "overflow-y": "auto" }}>
          {data !== undefined && data.length > 0 ?
            data.map((item, idx) => (
              <Box mt="30px" padding="24px" sx={{ border: "1px solid #E4E4E4", "box-sizing": "border-box", "border-radius": "10px" }}>
                <Box sx={{ display: "flex", "justify-content": "space-between", "align-items": "center" }} pb="16px">
                  <Box sx={{ display: "flex", "align-items": "center" }}>
                    <Typography fontSize={20} lineHeight="30px" color="#404349" fontWeight="500">
                      {Util.formatData(item?.name, "-")}
                    </Typography>
                    <img src={vector} alt="vector" style={{ height: "20px", margin: "0 15px 0 30px" }} />
                    <Typography fontSize={18} lineHeight="27px" color="#5DA196" fontWeight="400">{item?.type === "goal_and_competency" ? "Goals & Competencies" : item?.type === "goal" ? "Goals" : "Competencies"}</Typography>
                  </Box>
                  <Typography fontSize={14} lineHeight="20.93px" color="#858585" fontWeight="300">{Util.formatData(Util.dateDayFormat(item?.end_at), "-")}</Typography>
                </Box>
                <Divider />
                <Box py="20px">
                  <Typography pb="18px" fontSize={18} lineHeight="26.91px" color="#404349">
                    {Util.formatData(item?.description, "-")}
                  </Typography>
                  <Box sx={{ display: "flex" }}>
                    <Box sx={{ width: "200px" }} pr="10px">
                      <Typography pb="6px" fontSize={18} lineHeight="26.91px" color="#A3A3A3">{t('evaluation.goalMetric')}</Typography>
                      <Typography fontSize={18} lineHeight="26.91px" color="#404349">{Util.formatData(item?.goal_metric, "-")}</Typography>
                    </Box>
                    <Box sx={{ width: "calc(100% - 200px)" }} pr="10px">
                      <Typography pb="6px" fontSize={18} lineHeight="26.91px" color="#A3A3A3">{t('evaluation.targetValue')}</Typography>
                      <Typography fontSize={18} lineHeight="26.91px" color="#404349" sx={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", width: "100%" }}>{item?.goal_metric === "Date" ? Util.formatDate2(item?.metric_value, "-") : Util.formatData(item?.metric_value, "-")} {Util.formatData(item?.metric_unit, "")}</Typography>
                    </Box>
                    {/* <Box sx={{ width: "200px" }} pr="10px">
                      <Typography pb="6px" fontSize={18} lineHeight="26.91px" color="#A3A3A3">Value Unit</Typography>
                      <Typography fontSize={18} lineHeight="26.91px" color="#404349">{Util.formatData(item?.metric_unit, "-")}</Typography>
                    </Box> */}
                  </Box>
                </Box>
                <Divider />
                <Box pt="20px" sx={{ display: "flex", "flex-flow": "row wrap", "align-items": "center" }}>
                  <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">{t('evaluation.attachment')}:</Typography>
                  {/* <Box sx={{ display: "flex" }}>
                    <img src={PdfIcon} alt="iconFile" style={{ height: "20px", margin: "0 10px" }} />
                    <Typography fontSize={18} lineHeight="26.91px" color="#404349">quotation01.pdf</Typography>
                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" color="#404349">,</Typography>
                  </Box> */}
                  {item?.achievement_file !== undefined && item?.achievement_file.length > 0 ?
                    item?.achievement_file.map((rs, idx) => (
                      <Box display="flex" alignItems="center" pl="10px">
                        <Typography pr="10px" fontSize={18} lineHeight="26.91px" color="#404349" sx={{ display: idx === 0 ? "none" : "block" }}>,</Typography>
                        <Box sx={{ width: "16px", height: "16px" }}>
                          {rs?.mime_type === "application/pdf" ?
                            <PdfIcon /> :
                            rs?.mime_type === "image/png" ?
                              <PngIcon /> :
                              rs?.mime_type === "image/jpeg" ?
                                <JpgIcon /> : <NullIcon />
                          }
                        </Box>
                        <Typography pl="10px"
                          sx={{
                            cursor: "pointer",
                            display: "-webkit-box",
                            "-webkit-line-clamp": 2,
                            "-webkit-box-orient": "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            '&:hover': {
                              textDecoration: "underline",
                            }
                          }}
                          onClick={() => openInNewTab(rs?.serial)}>
                          {rs?.name}
                        </Typography>

                      </Box>
                    ))
                    :
                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" color="#404349">-</Typography>
                  }
                </Box>
              </Box>
            ))
            :
            <Box sx={{ "padding-top": "50px", "text-align": "center", "padding-bottom": "50px" }}>
              <Nodata />
              <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                {t('label.noData')}
              </Typography>
            </Box>
          }
        </Box>
      </DialogContent>
    </Dialog >
  );
};
export default DialogAchievements;
